<template>
  <div class='cc-editor'>
    <div id="appy">
      <dropDown style="margin-left: 5px;" @copyToClipboard="copyToClipboard"></dropDown>
    </div>
    <div class="out-puts">
        <span>HTML output: <el-button @click="copyToClipboard" >copy</el-button></span>
        <div>
          <pre id="html-output"></pre>
        </div>
    </div>
  </div>
</template>

<script>
// import pell from 'pell';
import { exec, init } from 'pell'; // exec
import dropDown from '@/components/CollectConsent/dropDown.vue';

export default {
  components: {
    dropDown,
  },
  mounted() {
    this.callPell();
    const contentInput = document.getElementsByClassName('pell-content-custom-name');
    contentInput[0].setAttribute('id', 'input-editor');
    this.$emit('editorMounted');
  },
  methods: {
    callPell() {
      const editor = init({
        // pell needs an element to init the plugin
        element: document.getElementById('appy'),
        onChange: (html) => {
          document.getElementById('html-output').textContent = html;
        },
        defaultParagraphSeparator: 'br',
        styleWithCSS: false,
        actions: [
          'bold',
          'italic',
          'underline',
          'olist',
          'ulist',
          {
            name: 'link',
            result: () => {
              let url = window.prompt('Enter the link URL'); // eslint-disable-line
              url += '{{partnerUrlAppend}}';
              if (url) exec('createLink', url);
            },
          },
        ],
        classes: {
          actionbar: 'pell-actionbar-custom-name',
          button: 'el-button',
          content: 'pell-content-custom-name',
          selected: 'pell-button-selected-custom-name',
        },
      });

      // editor.content<HTMLElement>
      // To change the editor's content:
      editor.content.innerHTML = 'Paste your text here';
    },
    copyToClipboard(text) {
      const vm = this;
      const dummy = document.createElement('input');
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();

      try {
        // Now that we've selected the anchor text, execute the copy command
        const successful = document.execCommand('copy');

        if (successful) {
          vm.$notify({
            title: 'copy',
            message: `Copied: ${text}`,
            type: 'Info',
            duration: 4000,
          });
        } else {
          vm.$notify({
            title: 'copy',
            message: 'Could not copy selected variable',
            type: 'warning',
            duration: 4000,
          });
        }
        document.body.removeChild(dummy);
      } catch (err) {
        console.log('Oops, unable to copy');
        vm.$notify({
          title: 'copy',
          message: 'Oops, unable to copy',
          type: 'Info',
          duration: 0,
        });
        document.body.removeChild(dummy);
      }
    },
  },
};
</script>

<style lang="scss">
  #html-output,
  .pell-content-custom-name,
  .pell-actionbar-custom-name {
    margin: 10px;
  }

  #html-output,
  .out-puts {
    max-height: 1px;
    max-width: 1px;
    overflow: hidden;
  }

  #input-editor.pell-content-custom-name {
    border: 1px solid #ebeef5;
    padding: 5px;
    border-radius: 3px;
    position: relative;
    max-width: 100%;
    display: inline-block;
  }

  #html-output {
    margin: 5px 0px;
  }
</style>
